export default {
    getItemById(itemId) {
        return window.ApiClient.get(`/items/${itemId}`);
    },
};
